export const userDataTransform = (userData) => ({
  'User Id': userData.student?.email,
  is_license: !!userData.license?.id,
  is_subscription: userData.subscription?.isActive || false,
  license_at: userData.license?.createdAt,
  oral_level_id: userData.student?.talkProficiency?.label,
  oral_level_name: userData.student?.talkProficiency?.description,
  plan_id: userData.plan?.id,
  plan_name: userData.plan?.name,
  risk_payment: userData.riskPayment?.score,
  student_created: userData.createdAt,
  student_score: userData.engagement?.score,
  subscription_at: userData.subscription?.createdAt,
  theoretical_level_id: userData.student?.languageLevel?.id,
  theoretical_level_name: userData.student?.languageLevel?.title,
  user_life_cycle: userData.engagement?.lifecycle,
  terminated: userData?.terminated,
  terminatedDate: userData?.terminatedDate,
});

export const identifyDataTransform = (identifyData) => ({
  user_id: identifyData?.userId,
  user_properties: { ...identifyData?.props },
});
